export function trim(strValue) {
    if (strValue && typeof strValue === 'string') {
        return strValue.trim();
    }
    return strValue;
}


export default { trim }
